import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'translate',
  pure: false, // Allows automatic recalculation when the language changes
})
export class TranslatePipe implements PipeTransform {
  translationService = inject(TranslationService);

  transform(value: string | undefined, params?: Record<string, string | number>): string {
    if (!value) {
      return '';
    }
    if (params) {
      return this.translationService.getWithParams(value, params);
    }
    return this.translationService.get(value);
  }
}
